import type { FaireProductEntity } from "../../entity_types/product";

export const p_74jd4t5e: FaireProductEntity = {
  token: "p_74jd4t5e",
  type: "product",
  name: "It's OK To Fart Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/res/hszgttpjt/image/upload/198d951b097f78fcd22ebe21750f922b7a1b77dc5b295f31f91b5349819b648b/1535409914.png",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/7b11b03c85552e5c26ca46e13761a88e6ac175f0a9e7ddb7b6f60da414f7228c/1555101971.jpg",
    "https://cdn.faire.com/fastly/31f1c05ecdd3e7482fba6518dca8f84dcc4e329a7165eeb58f3654a20cd1d0db.jpeg",
    "https://cdn.faire.com/fastly/e905299ebf60a9a716c18bd0d111c686e98f2685ae50ec17f954482488815cd4.jpeg",
    "https://cdn.faire.com/res/hszgttpjt/image/upload/a3666156a51490eeb7032f71166988b4fa346f0ab0a17b82565dcd4594c1beb9/1555101982.jpg",
    "https://cdn.faire.com/res/hszgttpjt/image/upload/a210dcd4a1d3e6fe3628d63da05a6a04328a75c565b41c59073a0a05538d8117/1521553577.jpg",
    "https://cdn.faire.com/res/hszgttpjt/image/upload/d20b5ce192f00eef308428cd412a4b40d55aa12002826043abe808961ef2c860/1521553590.jpg"
  ],
  priceDollars: 6.75,
  description: "Ahhh Farts - As natural as breathing and blinking, but we’ve heard some… rumblings… that farts are frowned upon??? Not to us!!! Let it out! Feel better? OK! Now you see how we came up with the sock.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance. \n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:31:22.273Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
